<template>
  <div class="carts">
    <section class="two-columns">
      <main class="two-columns__main">
        <h1 class="carts-title">ショッピングカート</h1>
        <section class="carts-main">
          <p class="carts-main__ammount">数量</p>
          <Card
            :imgUrl="'https://d3grtcc7imzgqe.cloudfront.net/img/book_small/tokyu_kinhure_new.jpg'"
            :title="'TOEIC L&R TEST 出る特急 金のフレーズ'"
            :author="'TEX加藤(著)'"
            :price="'890'"
            :priceTax="'961'"
            :point="'89'"
            :pointRate="'10'"
          />
          <Card
            :imgUrl="'https://d3grtcc7imzgqe.cloudfront.net/img/book_small/tokyu_kinhure_new.jpg'"
            :title="'TOEIC L&R TEST 出る特急 金のフレーズ'"
            :author="'TEX加藤(著)'"
            :price="'890'"
            :priceTax="'961'"
            :point="'89'"
            :pointRate="'10'"
          />
          <Card
            :imgUrl="'https://d3grtcc7imzgqe.cloudfront.net/img/book_small/tokyu_kinhure_new.jpg'"
            :title="'TOEIC L&R TEST 出る特急 金のフレーズ'"
            :author="'TEX加藤(著)'"
            :price="'890'"
            :priceTax="'961'"
            :point="'89'"
            :pointRate="'10'"
          />
        </section>
        <section class="carts-under-area">
          <a href="#" class="btn-square">ショッピングを続ける</a>
        </section>
      </main>
      <section class="two-columns__side">
        <div class="carts-sum">
          <div class="carts-sum-price">
            <div class="carts-sum-price__head">小計(1点):</div>
            <div class="carts-sum-price__body">¥961 <span>税込</span></div>
          </div>
          <p class="carts-sum__point">この注文での獲得ポイント:<span>89pt</span></p>
          <div class="carts-sum-btn">
            <a href="#" class="btn-square">レジに進む</a>
          </div>
        </div>
      </section>
    </section>
  </div>
</template>

<script>
  import Card from './parts/Card.vue';

  export default {
    title: 'ショッピングカート | abceed（No.1 TOEIC教材アプリ）',
    headerTitle: 'ショッピングカート',
    description: '',
    keywords: 'toeic,abceed,abceed analytics premium,globee,ショッピングカート',
    headerType: 'historyBack',
    components: { Card },
    data() {
      return {
      }
    },
    methods: {
    },
  }
</script>

<style scoped lang="scss">
  .carts-title {
    font-size: 20px;
    @media screen and (max-width: 768px){
      font-size: 18px;
    }
    font-weight: bold;
    text-align: left;
  }

  .carts-main {
    &__ammount {
      text-align: right;
      font-size: 12px;
    }
  }

  .carts-under-area {
    padding: 30px 0;
    @media screen and (max-width: 768px){
      padding: 20px 0 30px;
    }
    .btn-square {
      margin: 0 auto;
      height: 30px;
      width: 240px;
    }
  }

  .carts-sum {
    padding: 10px;
    border: 1px solid #D8D8D8;
    border-radius: 4px;
    text-align: left;
    &__point {
      font-size: 12px;
      margin-bottom: 15px;
      span {
        color: #FF5B60;
      }
    }
  }

  .carts-sum-price {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    max-width: 280px;
    &__head {
      font-weight: bold;
    }
    &__body {
      text-align: right;
      color: #FF5B60;
      span {
        font-size: 12px;
      }
    }
  }

  .carts-sum-btn {
    .btn-square {
      margin: 0 auto;
      height: 30px;
      @media screen and (max-width: 768px){
        width: 240px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/carts/Home.vue